module.exports = __webpack_public_path__ + "img/cjwt.4c152191.jpg";